import { render, staticRenderFns } from "./VariableInserter.vue?vue&type=template&id=7f822ac2&scoped=true"
import script from "./VariableInserter.vue?vue&type=script&lang=js"
export * from "./VariableInserter.vue?vue&type=script&lang=js"
import style0 from "./VariableInserter.vue?vue&type=style&index=0&id=7f822ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f822ac2",
  null
  
)

export default component.exports